import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: WateringUpdateInput!
  ) {
    updateOneWatering(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Rega actualizada`, mutationTypes.UPDATE)
)

